<ion-header class="ion-padding-start shadow-none ion-no-margin bg-transparent">
  <ion-toolbar class="ion-no-padding">
    <ion-text class="page-title ion-no-margin font-family-bold pb-0">
      {{'VEHICLE_SPECIFICATION' | translate}}
    </ion-text>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="vehicle-specification-modal ion-padding-horizontal ion-padding-bottom">
  <p class="modal-subtitle mb-4">
    {{ 'STANDARD_VEHICLE_INFORMATION_INTRO' | translate }}
  </p>

  @if (isLoading) {
  <div class="state-message py-4 text-center">
    {{ 'LOADING' | translate }}
  </div>
  }
  @else if (loadFailed) {
  <div class="state-message py-4 text-center">
    {{ 'STANDARD_VEHICLE_INFORMATION_LOAD_ERROR' | translate }}
  </div>
  }
  @else {
  <ion-accordion-group [multiple]="true">
    <ion-accordion value="standard-equipment">
      <ion-item slot="header" lines="full" class="section-accordion">
        <ion-label class="section-title">{{ 'STANDARD_EQUIPMENT' | translate }}</ion-label>
      </ion-item>

      <div slot="content" class="section-content">
        @if (standardEquipment.length > 0) {
        <ion-accordion-group [multiple]="true">
          @for (category of standardEquipment; track category.category; let index = $index) {
          <ion-accordion [value]="'se-' + index">
            <ion-item slot="header" lines="none" class="subcategory-accordion">
              <ion-label class="subcategory-title">{{ category.category }}</ion-label>
            </ion-item>

            <div slot="content" class="item-list">
              @for (item of category.items; track item.name + '-' + $index) {
              <div class="item-row">
                <div class="item-title">{{ item.name }}</div>
              </div>
              }
            </div>
          </ion-accordion>
          }
        </ion-accordion-group>
        }
        @else {
        <div class="state-message py-3">
          {{ 'STANDARD_VEHICLE_INFORMATION_EMPTY' | translate }}
        </div>
        }
      </div>
    </ion-accordion>

    <ion-accordion value="technical-specification">
      <ion-item slot="header" lines="full" class="section-accordion">
        <ion-label class="section-title">{{ 'TECHNICAL_SPECIFICATION' | translate }}</ion-label>
      </ion-item>

      <div slot="content" class="section-content">
        @if (technicalSpecification.length > 0) {
        <ion-accordion-group [multiple]="true">
          @for (category of technicalSpecification; track category.category; let index = $index) {
          <ion-accordion [value]="'ts-' + index">
            <ion-item slot="header" lines="none" class="subcategory-accordion">
              <ion-label class="subcategory-title">{{ category.category }}</ion-label>
            </ion-item>

            <div slot="content" class="item-list">
              @for (item of category.items; track item.name + '-' + item.value) {
              <div class="item-row item-row--pair">
                <div class="item-label">{{ item.name }}</div>
                <div class="item-value">{{ item.value }}</div>
              </div>
              }
            </div>
          </ion-accordion>
          }
        </ion-accordion-group>
        }
        @else {
        <div class="state-message py-3">
          {{ 'STANDARD_VEHICLE_INFORMATION_EMPTY' | translate }}
        </div>
        }
      </div>
    </ion-accordion>
  </ion-accordion-group>
  }
</ion-content>